<template>
  <div class="relative" style="min-width: 200px">
    <input
      ref="order_detail_code"
      type="text"
      :disabled="disabled"
      class="w-full border-0 bg-transparent p-0 placeholder-gray-200 focus:border-0 focus:ring-0 sm:text-sm"
      placeholder="Kode Barang"
      v-model="search"
      @change="onSearchProduct"
    />
    <button
      v-if="!disabled"
      type="button"
      @click="onOpenStockModal"
      class="absolute inset-y-0 top-0 right-0 flex cursor-pointer items-center pl-3"
    >
      <Icon icon="heroicons:magnifying-glass-circle-solid" class="h-5 w-5" />
    </button>

    <order-detail-modal
      v-if="type === 'order-detail'"
      :visible="modal.visible"
      :order-id="orderId"
      @close="modal.visible = false"
      @click-order-detail="onChangeProduct"
    />
    <stock-modal
      v-else-if="type === 'stock'"
      :visible="modal.visible"
      :columns="stockModalColumns"
      :warehouse-id="originWarehouse.id"
      :request-params="stockRequestParams"
      :check-stock-real="checkStockReal"
      :check-stock-and-free-real="checkStockAndFreeReal"
      :check-stock-loan="checkStockLoan"
      :check-published="checkPublished"
      v-bind="stockModalProps"
      @close="modal.visible = false"
      @click-stock="onChangeProduct"
    />
    <product-modal
      v-else
      :visible="modal.visible"
      :office-id="originOffice.id"
      @close="modal.visible = false"
      @click-product="onChangeProduct"
    />
  </div>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import StockModal from '@/components/stock/stock-modal.vue';
import ProductModal from '@/components/product/product-modal.vue';
import OrderDetailModal from '../order-details/OrderDetailModal.vue';
import { mapActions } from 'vuex';

export default {
  mixins: [requestMixin],
  components: {
    StockModal,
    ProductModal,
    OrderDetailModal,
  },
  props: {
    disabled: Boolean,
    value: null,
    originalSearch: String,
    type: {
      type: String,
      default: 'stock',
    },
    originOffice: Object,
    originWarehouse: Object,
    stockRequestParams: Object,
    stockModalColumns: {
      type: Array,
      default: () => ['weight', 'price', 'stock_real'],
    },
    checkStockReal: {
      type: Boolean,
      default: true,
    },
    checkStockAndFreeReal: Boolean,
    checkStockLoan: Boolean,
    checkPublished: Boolean,
    orderId: String,
    stockModalProps: Object
  },
  emits: ['input', 'update:loading', 'change'],
  data() {
    return {
      modal: {
        index: null,
        visible: false,
      },
    };
  },
  computed: {
    search: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onChangeProduct(stockOrOrderDetailOrProduct) {
      if (this.type === 'order-detail') {
        this.$emit('change', {
          orderDetail: stockOrOrderDetailOrProduct,
          product: { id: stockOrOrderDetailOrProduct.attributes.product_id },
          closeModal: () => (this.modal.visible = false),
        });
      } else {
        this.$emit('change', {
          product:
            this.type === 'stock'
              ? stockOrOrderDetailOrProduct.relationships.product.data
              : stockOrOrderDetailOrProduct,
          stock: stockOrOrderDetailOrProduct,
          closeModal: () => (this.modal.visible = false),
        });
      }
    },
    onOpenStockModal(index) {
      this.modal.index = index;
      this.modal.visible = true;
    },
    async onSearchProduct() {
      this.$emit('update:loading', true);

      const [stockOrOrderDetailOrProduct, err] = await this.searchProduct();

      if (err) {
        this.search = this.originalSearch;

        this.createAlert({
          data: 'Barang yang dicari tidak ditemukan',
          status: 'error',
        });
      } else {
        if (this.type === 'order-detail') {
          this.$emit('change', {
            orderDetail: stockOrOrderDetailOrProduct.orderDetail,
            product: stockOrOrderDetailOrProduct.product,
          });
        } else {
          this.$emit('change', {
            stock:
              this.type === 'stock' ? stockOrOrderDetailOrProduct.stock : null,
            product:
              this.type === 'stock'
                ? stockOrOrderDetailOrProduct.product
                : stockOrOrderDetailOrProduct,
          });
        }
      }

      this.$emit('update:loading', false);
    },
    async searchProduct() {
      if (this.type === 'order-detail') {
        const [res, err] = await this.request(
          `/api/v1/orders/${this.orderId}/order-details`,
          {
            params: {
              'fields[order-details]': 'product',
              'fields[products]': 'code',
              'filter[product_code]': this.search,
              include: 'product',
            },
          }
        );

        if (err || !res.data.length) {
          return [null, err || 'Produk tidak ditemukan'];
        }

        return [
          {
            orderDetail: res.data[0],
            product: this.getSingleIncluded(
              res,
              res.data[0].relationships.product.data.id
            ),
          },
          null,
        ];
      }

      const [res, err] =
        this.type === 'stock'
          ? await this.request(
              `/api/v1/warehouses/${this.originWarehouse.id}/stocks`,
              {
                params: {
                  'fields[stocks]': 'product_code,product_category_code,product_category_name,product',
                  'fields[products]': 'code',
                  'filter[product_code]': this.search,
                  ...(this.checkPublished ? { 'filter[published]': true } : {}),
                  include: 'product',
                  ...this.stockRequestParams
                },
              }
            )
          : await this.request(
              `/api/v1/offices/${this.originOffice.id}/products`,
              {
                params: {
                  'filter[code]': this.search,
                },
              }
            );

      if (err || !res.data.length) {
        return [null, err || 'Produk tidak ditemukan'];
      }

      if (this.type === 'stock') {
        return [
          {
            stock: res.data[0],
            product: this.getSingleIncluded(
              res,
              res.data[0].relationships.product.data.id
            ),
          },
          null,
        ];
      }

      return [res.data[0], null];
    },
  },
};
</script>
